exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".settings .wrapper-main .content p.extra-content{margin-top:5px}.settings .wrapper-main .content .profile-content.prof-container.profile.active form input[type=text],.settings .wrapper-main .content .profile-content.prof-container.profile.active form input[type=url]{color:#545454}.settings .wrapper-main .content .profile-content.prof-container.profile.active form input::placeholder{color:#cfcfd2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/settings/profile/profile.scss
// module id = 809
// module chunks = 0